import api from "@beeldit/core/helpers/api";

async function index(endpoint: string, filterPath: string = "") {
  return await api.get(`/${endpoint}?${filterPath}`);
}

export default index;
